<template>
  <div class="layout_content_sidebar">
    <el-menu class="my-el-menu-no-border" :router="true" :default-active="defaultActive">
      <!-- 超过默认页 -->
      <el-menu-item v-if="role === roleArray[2]" index="/home/superAdmin">
        <template slot="title">管理账号</template>
      </el-menu-item>

      <!-- 主管默认页  待处理方案-->
      <el-menu-item v-if="role === roleArray[0]" index="/home/steward">
        <template slot="title">待处理方案</template>
      </el-menu-item>

      <!-- 中心主任默认页 待认证用户 -->
      <el-menu-item v-if="role === roleArray[1]" index="/home/director">
        <template slot="title">待认证用户</template>
      </el-menu-item>

      <el-menu-item v-if="role !== roleArray[2]" index="/home/common/userAdmin">
        <template slot="title">用户管理</template>
      </el-menu-item>
      <el-menu-item v-if="role !== roleArray[2]" index="/home/common/schemeAdmin">
        <template slot="title">方案管理</template>
      </el-menu-item>

      <!-- 中心主任 课程管理 -->
      <el-menu-item v-if="role === roleArray[1]" index="/home/director/coursesAdmin">
        <template slot="title">课程管理</template>
      </el-menu-item>
      <!-- 中心主任 教师管理 -->
      <el-menu-item v-if="role === roleArray[1]" index="/home/director/teachersAdmin">
        <template slot="title">教师管理</template>
      </el-menu-item>
      <!-- 中心主任 基础设置 -->
      <el-submenu v-if="role === roleArray[1]" index="">
        <template slot="title">基础设置</template>
        <el-menu-item index="/home/director/baseSetting/price">
          <span slot="title">价格设置</span>
        </el-menu-item>
        <el-menu-item index="/home/director/baseSetting/hotelAdmin">
          <span slot="title">酒店列表</span>
        </el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>
<script>
import { role } from '~/utils/cadre.config'
export default {
  computed: {
    role () {
      return this.$store.state.userInfo.role
    },
    defaultActive () {
      return this.$route.path
    },
    roleArray () {
      return role
    }
  }
}
</script>
<style lang="scss" scoped>
  .layout_content_sidebar {
    width: $layout-sidebar-width;
    height: 100%;
    background-color: $color-white;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/content/sidebar/index.vue